import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// store
import { useSelector } from '../../../store';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// @moment
import moment from 'moment-timezone';
// utils
import { timezones } from '../../../utils/format';
// styles
import { MoreButton } from '../../../styles';

// ----------------------------------------------------------------------

interface Props {
  row: {
    memberId: string;
    organization: string;
    identification: string;
    email: string;
    role: string;
    blocked: boolean;
    locked: boolean;
    expirationAt: string;
    createdAt: string;
  };
  setDialog: React.Dispatch<React.SetStateAction<{
    visible: boolean;
    type: any;
    title: any;
    id: any;
    identification: any;
  }>>;
  handleTemp: (id: string, identification: string) => Promise<void>;
  setForm: React.Dispatch<any>;
};

// ----------------------------------------------------------------------

export default function TableRow({ row, setDialog, handleTemp, setForm }: Props){
  const navigate  = useNavigate();
  const account = useSelector((state) => state.account);

  const expirationAt = timezones(row.expirationAt, 'YYYY-MM-DD');
  const createdAt = timezones(row.createdAt, 'YYYY-MM-DD HH:mm:ss');

  const [ visible, setVisible ] = useState(false);
  
  return (
    <tr>
      <td>{row.organization}</td>
      <td>{row.identification}</td>
      <td>{row.email}</td>
      <td>{row.role}</td>
      <td>{row.blocked ? '비활성화' : '활성화'}</td>
      <td>{row.locked ? '차단' : '미차단'}</td>
      <td>{ expirationAt }</td>
      <td>{ createdAt }</td>
      <td>
        <MoreButton id={`more${row.memberId}`} className='more' onClick={() => setVisible(true)} disabled={row.identification === account.identification ? true : false} />
        <Popover
          target={`#more${row.memberId}`}
          visible={visible}
          hideOnOutsideClick={true}
          onHiding={() => setVisible(false)}
          position='left'
        >
          <button
            onClick={() => {
              setVisible(false);
              setDialog(row.blocked ? { visible: true, type: 'unblock', title: '활성화', id: row.memberId, identification: null } : { visible: true, type: 'block', title: '비활성화', id: row.memberId, identification: null });
            }}
          >
            계정 {row.blocked ? '활성화' : '비활성화'}
          </button>

          { row.locked &&
            <button
              onClick={() => {
                setVisible(false);
                setDialog({ visible: true, type: 'unlock', title: '차단 해제', id: row.memberId, identification: null });
              }}
            >
              차단 해제
            </button>
          }

          <button
            onClick={() => {
              setVisible(false);
              handleTemp(row.memberId, row.identification);
            }}
          >
            임시 비밀번호 발급
          </button>
          
          <button
            onClick={() => {
              setVisible(false);
              setForm({ id: row.memberId, expiration: row.expirationAt });
            }}
          >
            계정 만료일 변경
          </button>

          <button
            onClick={() => navigate('update', {state: row})}
          >
            수정
          </button>

          <button
            onClick={() => {
              setVisible(false);
              setDialog({ visible: true, type: 'delete', title: '삭제', id: row.memberId, identification: null });
            }}
          >
            삭제
          </button>
        </Popover>
      </td>
    </tr>
  );
}